import { Link as RouterLink } from 'react-router-dom';
import { Grid, Typography, Stack, Button, Box } from '@mui/material';
import Error404 from 'assets/images/Error404.png';

export default function NotFound() {
  const isAuthenticated = !!localStorage.getItem('token');

  return (
    <Grid
      container
      spacing={5}
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: '100vh', textAlign: 'center', px: 2 }}
    >
      <Grid item xs={12}>
        <Stack direction="row" justifyContent="center" spacing={2} flexWrap="wrap">
          <Box component="img" alt="mantis" src={Error404} sx={{ maxWidth: 400, width: '100%' }} />
        </Stack>
      </Grid>

      {/* Text + Button */}
      <Grid item xs={12}>
        <Stack alignItems="center" spacing={2}>
          <Typography variant="h1">Page Not Found</Typography>
          <Typography align="center" color="text.secondary" sx={{ maxWidth: 600 }}>
            The page you are looking for was moved, removed, renamed, or might never exist!
          </Typography>

          {isAuthenticated ? (
            <Button variant="contained" component={RouterLink} to="/dashboard" disableElevation>
              Back To Dashboard
            </Button>
          ) : (
            <Button variant="contained" component={RouterLink} to="/login" disableElevation>
              Back To Login
            </Button>
          )}
        </Stack>
      </Grid>
    </Grid>
  );
}
